import { useDecision } from '@optimizely/react-sdk';
import Cookies from 'js-cookie';

import useUser from 'Utilities/hooks/useUser';

import { useOptimizelyUserAttributes } from './useOptimizelyUserAttributes';

export interface UseOptimizelyDecisionProps {
	attributes?: Record<string, string | boolean>;
	experimentId: string;
}

export interface UseOptimizelyDecision {
	decision: Nullable<string>;
	isEnabled: boolean;
}

export const useOptimizelyDecision = ({
	attributes,
	experimentId,
}: UseOptimizelyDecisionProps): UseOptimizelyDecision => {
	const userAttributes = useOptimizelyUserAttributes();
	const { id: dealerContactId } = useUser();
	const [decision, clientReady] = useDecision(
		experimentId,
		{ autoUpdate: true },
		{
			overrideAttributes: {
				...userAttributes,
				...attributes,
			},
			overrideUserId: `${dealerContactId}`,
		},
	);

	// This allows us to set decisions in cypress tests
	const experimentDecisionCookie = Cookies.get(experimentId);

	if (experimentDecisionCookie) {
		return {
			decision: experimentDecisionCookie,
			isEnabled: true,
		};
	}

	if (decision.enabled && clientReady) {
		return {
			decision: decision.variationKey,
			isEnabled: decision.enabled,
		};
	}

	return {
		decision: null,
		isEnabled: false,
	};
};
